import React, { createContext, useContext } from 'react'

interface PlatformContextValue {
  isIOS: boolean
}

const PlatformContext = createContext<PlatformContextValue>({ isIOS: false })

interface ProviderProps {
  isIOS: boolean
  children: React.ReactNode
}

export const PlatformProvider: React.FC<ProviderProps> = ({ isIOS, children }) => (
  <PlatformContext.Provider value={{ isIOS }}>{children}</PlatformContext.Provider>
)

export const useIsIOSPlatform = (): boolean => useContext(PlatformContext).isIOS
